import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemProvider } from './store/ThemeContext';
import { MainProvider } from './store/MainContext';
import { Provider } from 'react-redux';
import { store } from './store/store';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemProvider>
        <MainProvider>
          <App />
        </MainProvider>
      </ThemProvider>
    </Provider>
  </React.StrictMode>,
);
